import React from "react";

function ViewAllUsers() {
  return <div>ViewAllUsers</div>;
}

export default ViewAllUsers;
